<template>
  <div class="hello">
    <div class="wh10header">
      <div class="headmid">
        <div class="hmidleft"></div>
        <div class="hmidright">
          <div>
            <router-link to="/home">首页</router-link>
            <p></p>
          </div>
          <div style="width: 64px" class="listt">
            <router-link to="/plantform/6">产品中心</router-link>
            <router-link to="/plantform" style="visibility: hidden"></router-link>
            <p></p>
            <!-- <ul class="listpro" style="text-align: center">

              <li>
                <router-link to="/plantform/6">开源因子库</router-link>
              </li>
              <li>
                <router-link to="/plantform/1">可视化的策略构建平台</router-link>
              </li>
              <li>
                <router-link to="/plantform/0">另类数据</router-link>
              </li>
              <li>
                <router-link to="/plantform/5">策略案例</router-link>
              </li>

            </ul> -->
          </div>
          <!-- <div>
            <router-link to="/dict">因子列表</router-link>
            <p></p>
          </div> -->
          <div>
            <router-link to="/download">下载</router-link>
            <p></p>
          </div>
          <div>
            <router-link to="/buy">购买</router-link>
            <p></p>
          </div>
          <div>
            <router-link to="/service">服务</router-link>
            <p></p>
          </div>
          <div>
            <router-link to="/gardenfirst">参考资料</router-link>
            <router-link to="/garden" style="visibility: hidden"></router-link>
            <p></p>
          </div>
          <div style="padding-right: 0">
            <router-link to="/about">关于<common-data name="appShortName_37"/></router-link>
            <p></p>
          </div>
        </div>
      </div>
    </div>
    <router-view class="htmid"></router-view>
    <iframe src="https://www.wenhua.com.cn/popwin/footer_wenhua.html" frameborder="0" style="min-width: 1400px;width: 100%;height: 64px;margin: 0 auto;display:block"></iframe>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data(){
    return{
    }
  },
  mounted() {
  // if(process.env.NODE_ENV=="production"&&!window.location.host.includes('wh11')){
  //     window.location.href='https://wh11.wenhua.com.cn/#'+this.$route.path
  //   }
  //   if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
  //     document.getElementsByClassName("wh10header")[0].style.position =
  //       "absolute";
  //   }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.wh10footer {
  text-align: center;
  min-width: 1400px;
  width: 100%;

  height: 64px;

  margin: 0 auto;
  background-color: #1d2429;
  color: #e8e9ed;
  font-size: 12px;
  line-height: 20px;
}
.wh10header {
  position: fixed;
  top: 0;
  min-width: 1400px;
  width: 100%;
  height: 70px;
  text-align: center;
  z-index: 99999;
  background: white;
  line-height: 70px;
  filter: drop-shadow(0 2px 2px #a78f8f);
  /* border-bottom: 2px solid #a78f8f; */
}
.headmid {
  width: 1050px;
  height: 70px;
  margin: 0 auto;
}
.hmidleft {
  height: 76px;
  width: 255px;
  float: left;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=51) no-repeat left;
}
.hmidright {
  /* width: 684px; */
  float: right;
  height: 70px;
  text-align: right;
}
.hmidright div {
  padding: 0 20px;
  display: inline-block;
  vertical-align: top;
}
.hmidright a {
  color: #404040;
  text-decoration: none;
  font-size: 16px;
}
.hmidright a:visited {
  color: #404040;
}
.htmid {
  min-height: 600px;
  margin-top: 72px;
  background: url("../assets/img/BG_02.png") no-repeat center 319px, #fdfcfa;
  width: 100%;
  min-width: 1400px;
}
.hmidright p {
  height: 6px;
  border-radius: 200px;
  margin-top: -20px;
}
html > body .router-link-active + p {
  background-image: linear-gradient(#fd7f44, #fe6147, #fc4f53);
  background-image: -webkit-linear-gradient(#fd7f44, #fe6147, #fc4f53);
  background-image: -o-linear-gradient(#fd7f44, #fe6147, #fc4f53);
  background-image: -moz-linear-gradient(#fd7f44, #fe6147, #fc4f53);
}
html > body .router-link-active + a + p {
  background-image: linear-gradient(#fd7f44, #fe6147, #fc4f53);
  background-image: -webkit-linear-gradient(#fd7f44, #fe6147, #fc4f53);
  background-image: -o-linear-gradient(#fd7f44, #fe6147, #fc4f53);
  background-image: -moz-linear-gradient(#fd7f44, #fe6147, #fc4f53);
}
.listpro {
  width: 100px;
  height: 0px;
  margin-top: 13px;

  background: white;
  overflow: hidden;
  transition: height 0.5s;
  -moz-transition: height 0.5s; /* Firefox 4 */
  -webkit-transition: height 0.5s; /* Safari and Chrome */
  -o-transition: height 0.5s; /* Opera */
}
.listt:hover .listpro {
  height: 105px;
}
.listpro li {
  padding-left: 15px;
  text-align: left;
  width: 200px;
  z-index: 108;
  height: 35px;
  line-height: 35px;
  background: white;
}
.listpro li:hover{
  background: #ffeded;
}
.listpro a {
  display: inline-block;
  width: 200px;
}
.wh10header a:hover {
  color: #902c2c;
}
.wh10footer span {
  padding-right: 15px;
}
.list2 li {
  text-align: left;
  padding-left: 15px;
}
</style>
